import { Box, Divider } from '@mui/material';
import { styled } from '@mui/material';

import { LobsterXml } from './lobster-xml';
import { StatusScale } from './status-scale';
import { SystemCache } from './system-cache';
import { SystemLogs } from './system-logs';

// A settings form has no business running the width of a 1920 screen, but it
// should sit on the canvas like everything else: card, PALO gutter, no 62px
// legacy inset.
const Container = styled(Box)(({ theme }) => ({
    margin: theme.spacing(2),
    padding: theme.spacing(3),
    flex: 1,
    maxWidth: 900,
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    alignSelf: 'flex-start',
}));

export const SystemSettings = () => {
    return (
        <Container>
            <SystemCache />
            <Divider sx={{ my: 3 }} />
            <LobsterXml />
            <Divider sx={{ my: 3 }} />
            <StatusScale />
            <Divider sx={{ my: 3 }} />
            <SystemLogs />
        </Container>
    );
};
